
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.282 14.188l.083.197.189-.068c3.031-1.057 6.337-.008 8.016 2.528l.136.214.122.21.112.212.084.172 1.472 3.156c.603 1.295.085 2.846-1.188 3.63l-.064.035 1.282 2.612a.761.761 0 01-.171.898l-.088.069-.09.051-.026.012a.813.813 0 01-1.006-.292l-.053-.093-1.264-2.578-4.792 2.234 1.217 2.483a.76.76 0 01-.172.898l-.088.069-.09.052-.024.011a.813.813 0 01-1.006-.292l-.054-.093-1.208-2.463-.142.061c-1.262.5-2.677.113-3.432-.916l-.098-.145-.09-.152-.08-.156-1.481-3.177-.078-.176c-1.188-2.79-.221-6.057 2.276-7.963l.218-.16.146-.102-.004-.012c-1.697-4.096-3.53-5.338-5.81-4.021l-.157.094-.158.101c-1.307.872-1.683 2.247-1.397 5.17l.069.628.222 1.707.079.66c.389 3.493.07 4.816-1.432 5.95-2.67 2.015-5.462 1.768-8.094-.702a.85.85 0 011.164-1.24c2.036 1.911 3.91 2.092 5.906.584.879-.663 1.07-1.69.76-4.457l-.071-.597-.18-1.363-.081-.682c-.42-3.862.115-5.74 2.113-7.072 3.377-2.252 6.329-.727 8.503 4.274zm8.788 7.316l-9.898 4.499.033.071c.263.564.912.843 1.534.684l.133-.041.127-.053 7.36-3.431c.602-.281.922-.92.786-1.51l-.037-.124-.038-.095zm-8.575-5.528c-2.51 1.17-3.772 3.92-2.987 6.367l.075.215.082.207.068.153.931 1.997 9.899-4.5-.974-2.09-.073-.151c-1.25-2.46-4.358-3.44-7.02-2.198z"}})])
          )
        }
      }
    